var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { createStripeCustomer, createStripeSubscription, } from "../../actions/subscriptions";
import { getMyAgencies } from "../../actions/agencies";
var CARD_ELEMENT_OPTIONS = {
    style: {
        base: {
            fontSize: "16px",
            color: "#fff",
            "::placeholder": { color: "#a3a3a3" },
            fontFamily: "inherit",
            letterSpacing: "0.025em",
            backgroundColor: "transparent",
            iconColor: "#a3a3a3",
        },
        invalid: { color: "#ef4444" },
    },
    hidePostalCode: true,
};
var PaymentForm = function (_a) {
    var priceId = _a.priceId, planName = _a.planName;
    var stripe = useStripe();
    var elements = useElements();
    var _b = useState(""), name = _b[0], setName = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(null), subscriptionStatus = _e[0], setSubscriptionStatus = _e[1];
    var _f = useState(""), coupon = _f[0], setCoupon = _f[1];
    var _g = useState(""), referralCode = _g[0], setReferralCode = _g[1];
    var _h = useState(null), agency = _h[0], setAgency = _h[1];
    var _j = useState(false), wantInvoice = _j[0], setWantInvoice = _j[1];
    var _k = useState("pf"), personType = _k[0], setPersonType = _k[1];
    var _l = useState(""), cpfCnpj = _l[0], setCpfCnpj = _l[1];
    var _m = useState(""), companyName = _m[0], setCompanyName = _m[1]; // Razão Social ou Nome completo
    var _o = useState(""), stateReg = _o[0], setStateReg = _o[1]; // IE (opcional)
    var _p = useState(""), cep = _p[0], setCep = _p[1];
    var _q = useState(""), addressLine = _q[0], setAddressLine = _q[1];
    var _r = useState(""), addressNumber = _r[0], setAddressNumber = _r[1];
    var _s = useState(""), addressComplement = _s[0], setAddressComplement = _s[1];
    var _t = useState(""), neighborhood = _t[0], setNeighborhood = _t[1];
    var _u = useState(""), city = _u[0], setCity = _u[1];
    var _v = useState(""), uf = _v[0], setUf = _v[1];
    var _w = useState(""), nfeEmail = _w[0], setNfeEmail = _w[1];
    React.useEffect(function () {
        getMyAgencies().then(function (agencies) {
            // Supondo que o usuário só tenha uma agência principal
            if (agencies && agencies.length > 0) {
                setAgency(agencies[0]);
            }
        });
    }, []);
    // (Opcional) máscara simples
    var handleCpfCnpj = function (v) {
        var only = v.replace(/\D/g, "");
        if (personType === "pf") {
            only = only.slice(0, 11);
            // 000.000.000-00
            if (only.length > 9)
                only = only.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
            else if (only.length > 6)
                only = only.replace(/(\d{3})(\d{3})(\d{0,3})/, "$1.$2.$3");
            else if (only.length > 3)
                only = only.replace(/(\d{3})(\d{0,3})/, "$1.$2");
        }
        else {
            only = only.slice(0, 14);
            // 00.000.000/0000-00
            if (only.length > 12)
                only = only.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
            else if (only.length > 8)
                only = only.replace(/(\d{2})(\d{3})(\d{3})(\d{0,4})/, "$1.$2.$3/$4");
            else if (only.length > 5)
                only = only.replace(/(\d{2})(\d{3})(\d{0,3})/, "$1.$2.$3");
            else if (only.length > 2)
                only = only.replace(/(\d{2})(\d{0,3})/, "$1.$2");
        }
        setCpfCnpj(only);
    };
    var handleCep = function (v) {
        var only = v.replace(/\D/g, "").slice(0, 8);
        if (only.length > 5)
            only = only.replace(/(\d{5})(\d{0,3})/, "$1-$2");
        setCep(only);
    };
    var buildInvoiceData = function () {
        if (!wantInvoice)
            return undefined;
        return {
            person_type: personType,
            cpf_cnpj: cpfCnpj.replace(/\D/g, ""),
            name: companyName || name,
            ie: stateReg || null,
            cep: cep.replace(/\D/g, ""),
            address_line: addressLine,
            number: addressNumber,
            complement: addressComplement,
            neighborhood: neighborhood,
            city: city,
            state: uf,
            email: nfeEmail || undefined,
        };
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, stripeError, paymentMethod, customerData, subscriptionData, confirmError, err_1, backendError, friendlyError;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    e.preventDefault();
                    setLoading(true);
                    setError(null);
                    if (!stripe || !elements) {
                        setError("Stripe não carregado.");
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 7, 8, 9]);
                    return [4 /*yield*/, stripe.createPaymentMethod({
                            type: "card",
                            card: elements.getElement(CardElement),
                            billing_details: { name: name },
                        })];
                case 2:
                    _a = _d.sent(), stripeError = _a.error, paymentMethod = _a.paymentMethod;
                    // console.log('PaymentMethod criado:', paymentMethod);
                    if (stripeError || !paymentMethod) {
                        console.error('Erro ao criar PaymentMethod:', stripeError);
                        throw stripeError || new Error("Erro ao criar PaymentMethod.");
                    }
                    return [4 /*yield*/, createStripeCustomer(name, paymentMethod.id, buildInvoiceData())];
                case 3:
                    customerData = _d.sent();
                    if (customerData.error)
                        throw new Error(customerData.error);
                    return [4 /*yield*/, createStripeSubscription(customerData.customer_id, priceId, planName, coupon || undefined, // ✅ Enviar cupom se preenchido (para todos os usuários)
                        referralCode || undefined, // ✅ Enviar referral APENAS se não vazio
                        buildInvoiceData())];
                case 4:
                    subscriptionData = _d.sent();
                    if (subscriptionData.error)
                        throw new Error(subscriptionData.error);
                    if (!(subscriptionData.status === "requires_action" ||
                        subscriptionData.status === "incomplete")) return [3 /*break*/, 6];
                    return [4 /*yield*/, stripe.confirmCardPayment(subscriptionData.client_secret)];
                case 5:
                    confirmError = (_d.sent()).error;
                    if (confirmError)
                        throw confirmError;
                    _d.label = 6;
                case 6:
                    setSubscriptionStatus("active");
                    return [3 /*break*/, 9];
                case 7:
                    err_1 = _d.sent();
                    console.error('Erro completo:', err_1);
                    backendError = ((_c = (_b = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error) || (err_1 === null || err_1 === void 0 ? void 0 : err_1.message) || "Erro ao processar assinatura.";
                    friendlyError = backendError;
                    if (/insufficient funds/i.test(backendError)) {
                        friendlyError = "Seu cartão não possui saldo suficiente.";
                    }
                    else if (/card was declined/i.test(backendError)) {
                        friendlyError = "O cartão foi recusado. Tente outro cartão ou verifique com seu banco.";
                    }
                    else if (/expired/i.test(backendError)) {
                        friendlyError = "O cartão está expirado.";
                    }
                    else if (/incorrect cvc/i.test(backendError) ||
                        /security code is incorrect/i.test(backendError)) {
                        friendlyError = "O código de segurança (CVC) está incorreto.";
                    }
                    setError(friendlyError);
                    return [3 /*break*/, 9];
                case 8:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "w-full max-w-md mx-auto" }, subscriptionStatus ? (React.createElement("div", { className: "flex flex-col items-center justify-center py-8" },
        React.createElement("svg", { className: "w-16 h-16 text-green-500 mb-4", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor" },
            React.createElement("circle", { cx: "12", cy: "12", r: "10", strokeWidth: "2", stroke: "currentColor", fill: "none" }),
            React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M8 12l2 2l4-4" })),
        React.createElement("h2", { className: "text-2xl font-bold text-green-400 mb-2" }, "Assinatura ativa!"),
        React.createElement("p", { className: "text-gray-300" }, "Sua assinatura foi criada com sucesso."),
        React.createElement("div", { className: "flex gap-4 mt-6" },
            React.createElement("button", { className: "px-6 py-2 rounded-lg bg-cyan-600 hover:bg-cyan-700 text-white font-bold shadow transition", onClick: function () { return window.location.href = "/subscription"; } }, "Acessar Planos"),
            React.createElement("button", { className: "px-6 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white font-bold shadow transition", onClick: function () { return window.location.href = "/clients"; } }, "Adicionar Clientes")))) : (React.createElement("form", { onSubmit: handleSubmit, className: "space-y-6" },
        React.createElement("div", null,
            React.createElement("label", { htmlFor: "name", className: "block text-sm font-medium text-gray-200 mb-1" }, "Nome do titular do cart\u00E3o"),
            React.createElement("input", { id: "name", type: "text", value: name, onChange: function (e) { return setName(e.target.value); }, placeholder: "Como est\u00E1 no cart\u00E3o", required: true, autoComplete: "cc-name", className: "w-full px-4 py-3 rounded-lg bg-gray-900 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500 transition" })),
        React.createElement("div", null,
            React.createElement("label", { className: "block text-sm font-medium text-gray-200 mb-1" }, "Dados do cart\u00E3o"),
            React.createElement("div", { className: "w-full px-4 py-3 rounded-lg bg-gray-900 border border-gray-700 focus-within:ring-2 focus-within:ring-green-500 transition" },
                React.createElement(CardElement, { options: CARD_ELEMENT_OPTIONS }))),
        React.createElement("div", null,
            React.createElement("label", { htmlFor: "coupon", className: "block text-sm font-medium text-gray-200 mb-1" }, "Cupom de desconto (opcional)"),
            React.createElement("input", { id: "coupon", type: "text", value: coupon, onChange: function (e) { return setCoupon(e.target.value); }, placeholder: "Digite o cupom", className: "w-full px-4 py-3 rounded-lg bg-gray-900 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-cyan-500 transition" })),
        !agency || !agency.affiliate ? (React.createElement("div", null,
            React.createElement("label", { htmlFor: "referral", className: "block text-sm font-medium text-gray-200 mb-1" }, "C\u00F3digo de indica\u00E7\u00E3o (opcional)"),
            React.createElement("input", { id: "referral", type: "text", value: referralCode, onChange: function (e) { return setReferralCode(e.target.value); }, placeholder: "Se voc\u00EA recebeu um c\u00F3digo de indica\u00E7\u00E3o", className: "w-full px-4 py-3 rounded-lg bg-gray-900 text-white border border-gray-700 focus:outline-none focus:ring-2 focus:ring-cyan-500 transition" }))) : null,
        React.createElement("div", { className: "p-4 border border-gray-700 rounded-lg bg-gray-900/60 space-y-4" },
            React.createElement("label", { className: "flex items-center gap-2 text-sm font-medium text-gray-200" },
                React.createElement("input", { type: "checkbox", className: "h-4 w-4", checked: wantInvoice, onChange: function (e) { return setWantInvoice(e.target.checked); } }),
                "Desejo emitir Nota Fiscal"),
            wantInvoice && (React.createElement("div", { className: "space-y-4" },
                React.createElement("div", { className: "flex gap-4" },
                    React.createElement("label", { className: "flex items-center gap-2 text-sm text-gray-300" },
                        React.createElement("input", { type: "radio", name: "personType", value: "pf", checked: personType === "pf", onChange: function () {
                                setPersonType("pf");
                                setCpfCnpj("");
                            } }),
                        "Pessoa F\u00EDsica"),
                    React.createElement("label", { className: "flex items-center gap-2 text-sm text-gray-300" },
                        React.createElement("input", { type: "radio", name: "personType", value: "pj", checked: personType === "pj", onChange: function () {
                                setPersonType("pj");
                                setCpfCnpj("");
                            } }),
                        "Pessoa Jur\u00EDdica")),
                React.createElement("div", { className: "grid grid-cols-1 gap-4" },
                    React.createElement("div", null,
                        React.createElement("label", { className: "block text-xs font-semibold text-gray-400 mb-1" }, personType === "pf" ? "CPF" : "CNPJ"),
                        React.createElement("input", { type: "text", value: cpfCnpj, onChange: function (e) { return handleCpfCnpj(e.target.value); }, required: true, className: "w-full px-3 py-2 rounded bg-gray-900 border border-gray-700 text-white text-sm" })),
                    React.createElement("div", null,
                        React.createElement("label", { className: "block text-xs font-semibold text-gray-400 mb-1" }, personType === "pf" ? "Nome completo (NF)" : "Razão Social"),
                        React.createElement("input", { type: "text", value: companyName, onChange: function (e) { return setCompanyName(e.target.value); }, placeholder: personType === "pf" ? "Nome completo para a NF" : "Razão Social", className: "w-full px-3 py-2 rounded bg-gray-900 border border-gray-700 text-white text-sm", required: true })),
                    personType === "pj" && (React.createElement("div", null,
                        React.createElement("label", { className: "block text-xs font-semibold text-gray-400 mb-1" }, "Inscri\u00E7\u00E3o Estadual (opcional)"),
                        React.createElement("input", { type: "text", value: stateReg, onChange: function (e) { return setStateReg(e.target.value); }, className: "w-full px-3 py-2 rounded bg-gray-900 border border-gray-700 text-white text-sm", placeholder: "ISENTO se aplic\u00E1vel" }))),
                    React.createElement("div", { className: "grid grid-cols-3 gap-3" },
                        React.createElement("div", { className: "col-span-2" },
                            React.createElement("label", { className: "block text-xs font-semibold text-gray-400 mb-1" }, "CEP"),
                            React.createElement("input", { type: "text", value: cep, onChange: function (e) { return handleCep(e.target.value); }, maxLength: 9, className: "w-full px-3 py-2 rounded bg-gray-900 border border-gray-700 text-white text-sm", required: true })),
                        React.createElement("div", null,
                            React.createElement("label", { className: "block text-xs font-semibold text-gray-400 mb-1" }, "UF"),
                            React.createElement("input", { type: "text", value: uf, onChange: function (e) { return setUf(e.target.value.toUpperCase().slice(0, 2)); }, className: "w-full px-3 py-2 rounded bg-gray-900 border border-gray-700 text-white text-sm", required: true }))),
                    React.createElement("div", null,
                        React.createElement("label", { className: "block text-xs font-semibold text-gray-400 mb-1" }, "Logradouro"),
                        React.createElement("input", { type: "text", value: addressLine, onChange: function (e) { return setAddressLine(e.target.value); }, className: "w-full px-3 py-2 rounded bg-gray-900 border border-gray-700 text-white text-sm", required: true })),
                    React.createElement("div", { className: "grid grid-cols-3 gap-3" },
                        React.createElement("div", null,
                            React.createElement("label", { className: "block text-xs font-semibold text-gray-400 mb-1" }, "N\u00FAmero"),
                            React.createElement("input", { type: "text", value: addressNumber, onChange: function (e) { return setAddressNumber(e.target.value); }, className: "w-full px-3 py-2 rounded bg-gray-900 border border-gray-700 text-white text-sm", required: true })),
                        React.createElement("div", { className: "col-span-2" },
                            React.createElement("label", { className: "block text-xs font-semibold text-gray-400 mb-1" }, "Complemento"),
                            React.createElement("input", { type: "text", value: addressComplement, onChange: function (e) { return setAddressComplement(e.target.value); }, className: "w-full px-3 py-2 rounded bg-gray-900 border border-gray-700 text-white text-sm", placeholder: "Opcional" }))),
                    React.createElement("div", { className: "grid grid-cols-2 gap-3" },
                        React.createElement("div", null,
                            React.createElement("label", { className: "block text-xs font-semibold text-gray-400 mb-1" }, "Bairro"),
                            React.createElement("input", { type: "text", value: neighborhood, onChange: function (e) { return setNeighborhood(e.target.value); }, className: "w-full px-3 py-2 rounded bg-gray-900 border border-gray-700 text-white text-sm", required: true })),
                        React.createElement("div", null,
                            React.createElement("label", { className: "block text-xs font-semibold text-gray-400 mb-1" }, "Cidade"),
                            React.createElement("input", { type: "text", value: city, onChange: function (e) { return setCity(e.target.value); }, className: "w-full px-3 py-2 rounded bg-gray-900 border border-gray-700 text-white text-sm", required: true }))),
                    React.createElement("div", null,
                        React.createElement("label", { className: "block text-xs font-semibold text-gray-400 mb-1" }, "E-mail para NF (opcional)"),
                        React.createElement("input", { type: "email", value: nfeEmail, onChange: function (e) { return setNfeEmail(e.target.value); }, className: "w-full px-3 py-2 rounded bg-gray-900 border border-gray-700 text-white text-sm", placeholder: "ex: fiscal@empresa.com" })),
                    React.createElement("p", { className: "text-[11px] text-gray-500" }, "Dados ser\u00E3o usados somente para emiss\u00E3o de Nota Fiscal (LGPD)."))))),
        React.createElement("button", { type: "submit", disabled: !stripe || loading, className: "w-full py-3 rounded-lg bg-green-600 hover:bg-green-700 transition text-white font-bold text-lg shadow-lg focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2" }, loading ? (React.createElement("span", { className: "flex items-center justify-center" },
            React.createElement("svg", { className: "animate-spin h-5 w-5 mr-2 text-white", viewBox: "0 0 24 24" },
                React.createElement("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4", fill: "none" }),
                React.createElement("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8v8z" })),
            "Processando...")) : ("Assinar")),
        error && (React.createElement("div", { className: "text-red-400 text-sm text-center mt-2 bg-red-900/40 rounded p-2 border border-red-700" }, error))))));
};
export default PaymentForm;
